import { useCallback } from 'react';
import { REFUND_LOG_COLUMN, REFUND_LOG_SORTING_COLUMN } from '../../constants/refundLogRow';
import refundLogStore from '../../store/refundLogStore';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';
import { SORTING_DIRECTION } from '~/constants/main';

interface ITitleProps {
  name: REFUND_LOG_SORTING_COLUMN;
  title: REFUND_LOG_COLUMN;
  tooltipMessage?: string;
}

export const RefundLogColumnTitle: React.FC<ITitleProps> = ({ name, title, tooltipMessage }) => {
  const onChangeSorting = useCallback((sortBy: REFUND_LOG_SORTING_COLUMN | undefined, sortDir: SORTING_DIRECTION) => {
    refundLogStore.setFilters({ sortBy, sortDir });
  }, []);

  return (
    <ColumnTitle<REFUND_LOG_SORTING_COLUMN>
      columnName={name}
      title={title}
      currentField={refundLogStore.filters.sortBy}
      currentDir={refundLogStore.filters.sortDir}
      setFilters={onChangeSorting}
      className={`cell-${title}`}
      tooltipMessage={tooltipMessage}
    />
  );
};
